module.exports = __webpack_public_path__ + "static/media/404_Error.020262e3.jpg";